import { Injectable, inject } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { TranslateService } from '../services/translate.service';
import { formatDateForDisplay } from '../../shared/utils/date.utils';

/**
 * DateAdapter que muestra en el input del datepicker "Hoy", "Mañana" o "Ayer" cuando aplica,
 * seguido de dd/mm/yyyy. Solo afecta la visualización; el valor (Date) no cambia.
 */
@Injectable()
export class AutodromoDateAdapter extends NativeDateAdapter {
  private readonly translate = inject(TranslateService);

  override format(date: Date, displayFormat: object): string {
    if (!this.isValid(date)) {
      throw Error('AutodromoDateAdapter: Cannot format invalid date.');
    }
    return formatDateForDisplay(date, (key) => this.translate.translate(key));
  }
}
